import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '¿Es en línea?',
  a: 'Sí, es un producto digital descargable (PDF) diseñado para leer cómodamente en cualquier dispositivo (teléfono, tablet o computadora).'
}, {
  q: '¿Sirve para cualquier edad?',
  a: 'Está optimizado específicamente para la fisiología de mujeres de 40 a 60 años que están experimentando cambios hormonales, perimenopausia o menopausia.'
}, {
  q: '¿Tengo que comprar comida especial o suplementos caros?',
  a: 'No, usamos alimentos reales que encuentras en cualquier supermercado del mundo. La guía de suplementos es opcional y te enseña a elegir opciones accesibles y efectivas.'
}];
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-32 bg-cream-dark" data-id="element-47">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-48">
        <div className="text-center mb-12" data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-50">
            Preguntas Frecuentes
          </h2>
          <p className="text-charcoal-light" data-id="element-51">
            Todo lo que necesitas saber antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-52">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-cream rounded-2xl border border-sage-100 overflow-hidden" data-id="element-53">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-54">
                  <span className="font-semibold text-lg pr-8" data-id="element-55">{faq.q}</span>
                  <div className="flex-shrink-0 text-sage-700" data-id="element-56">
                    {isOpen ? <Minus size={20} data-id="element-57" /> : <Plus size={20} data-id="element-58" />}
                  </div>
                </button>

                <AnimatePresence data-id="element-59">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-60">
                      <div className="px-6 pb-5 text-charcoal-light leading-relaxed" data-id="element-61">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}